'use client'
import React, {useState } from 'react';
import styled from "styled-components";
import {Col} from "react-bootstrap";
import {black, hover} from "@/styles/globalStyleVars";
import {Img} from "@/components/Img";
import Title from "@/components/Title";
import PopupV2 from "@/components/PopupV2";
import Button from "@/components/Button";
import parser from "html-react-parser";
import ThemeRow from "@/components/theme/row";

const AboutOverview = ({title,desc,image,text,fromHome,link, data}) => {


    const [show, setShow] = useState(false);
    const [popupId, setPopupId] = useState()
    const handleClose = () => setShow(false);
    const handleShow = (data) => {
        setShow(true)
        setPopupId(data)
    }
    return (
        <StyledComponent className={'overview '} id={'who_we_are'}>
            <ThemeRow rowClass={'reverse'}>
                <Col md={{span:6}} className={'overview__image'}>
                    <div className={'overview__img '}   >
                        <Img src={image} parallax />
                    </div>
                </Col>
                <Col md={{span:6}} className={'overview__text'}>
                    {
                        title &&
                        <Title text={title} fontWeight={800}/>

                    }

                    {
                        text && typeof text === 'string' &&
                        <h3 className={'split-up'}>{parser(text)}</h3>
                    }

                    {
                        desc && typeof desc === 'string' &&
                        parser(desc)
                    }
                    {
                        fromHome ?
                            <Col md={12} className={'overview__text__button p-0'} >
                                <Button src={'/about'} text={'Explore'} border={`1px`} borderColor={`#000`} color={`#000`} hoverBackground={`${hover}`}/>
                            </Col> :
                            <Col md={12} className={'overview__text__button p-0'} onClick={() => handleShow(data)} >
                                <Button text={'Read More'} src={'javascript:void(0)'} border={`1px`} borderColor={`#000`} color={`#000`} hoverBackground={`${hover}`}/>
                            </Col>
                    }
                </Col>
            </ThemeRow>
            <PopupV2 show={show} data={popupId} about handleClose={handleClose}/>
        </StyledComponent>
    );
};
const StyledComponent = styled.section`
    background: #F9F9F9;
    overflow: hidden;
    position: relative;
    .overview {
        position: relative;
        width: 100%;

        &__text {
            position: relative;

            &__button {
                margin-top: 40px;
            }

            h2{
                font-weight: 800;
            }
            h3 {
                margin-bottom: 30px;
                font-weight: 500;
            }

            p {
                color: ${black};
              
                margin-bottom: 24px;
           
                &:nth-of-type(2){
                    text-overflow: ellipsis;
                    word-wrap: break-word;
                    display: -webkit-box;
                    -webkit-line-clamp: 5;
                    -webkit-box-orient: vertical;
                    overflow: hidden;

                }
                @media (min-width: 992px) {
                    &:nth-of-type(2){
                        -webkit-line-clamp: 5;
                    }
                }
            }
        }

        &__img {
            position: relative;
            padding-top: calc(600 / 500 * 100%);
            width: 100%;
        }
    }

    .mobile {
        display: none;
    }

    .overview__text{
        padding-left: 85px;
        padding-top: 100px;
        padding-bottom: 100px;
    }
    .overview__image{
        border-right: 1px solid #D9D9D9;
        padding-right: 85px;
        padding-top: 100px;
        padding-bottom: 100px;
    }
    
    @media(max-width: 1024px) and (min-width: 768px){
        .overview__text{
            padding-left: 50px;
            padding-top: 100px;
            padding-bottom: 100px;
        }
        .overview__image{
            border-right: 1px solid #D9D9D9;
            padding-right: 50px;
            padding-top: 100px;
            padding-bottom: 100px;
        }
    }
    @media (max-width: 1050px) {
        .overview__text__button {
            bottom: -40px;
            z-index: 10;
        }
    }
    @media (max-width: 767px) {

        .overview__text{
            padding-left: 15px;
            padding-top: 60px;
            padding-bottom: 60px;
        }
        .overview__image{
            border-right: none;
            padding-right: 15px;
            padding-top: 60px;
            padding-bottom: 60px !important;
        }
        
        .mobile {
            display: block;
        }

        .reverse {
            flex-direction: column-reverse !important;
        }

        .overview {
            &__text {
                &overview__text__button {
                    bottom: -40px;
                }

                h5 {
                    margin-top: 40px;
                    margin-bottom: 30px;
                    font-size: 18px;
                    line-height: 22px;
                }

                p {
                    -webkit-line-clamp: 8;
                }
            }

            &__img {
                position: relative;
                padding-top: calc(414 / 345 * 100%);
            }
        }
    }
    @media (min-width: 1550px) {
        .overview {
            &__text {
                h5 {
                    font-size: 24px;
                    line-height: 28px;
                }

                p {
                    font-size: 18px;
                    line-height: 25px;
                }
            }
        }
    }
`
export default React.memo(AboutOverview);